/**
 * Side-effect module: initialises Sentry RUM. main.tsx imports it before App so that `Sentry.init`
 * has run by the time App.tsx evaluates `withSentryReactRouterV7Routing(Routes)`; wrapped any
 * earlier, the SDK returns plain `Routes` and route-pattern transaction names never turn on.
 *
 * Empty DSN: no init, zero network calls. Replay intentionally omitted (privacy and bandwidth).
 */
import * as Sentry from '@sentry/react';
import { reloadedForStaleChunk } from '../lib/chunkReload';
import { resolveSentryEnvironment } from './sentry';
import { initSentry } from './sentryInit';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn) {
  initSentry(
    sentryDsn,
    resolveSentryEnvironment(
      import.meta.env.VITE_SENTRY_ENVIRONMENT,
      import.meta.env.MODE,
      window.location.hostname,
    ),
  );
  // beforeSend drops the stale-chunk failure that triggered the reload; count the recovery here
  // (Sentry Logs, not an issue) so deploys that strand users on old chunks stay visible.
  if (reloadedForStaleChunk()) Sentry.logger.warn('chunk_reload.performed');
}
